import { z } from 'zod';
import { ABIS_DECISIONS } from '../constants/statuses.js';
import { paginationQuerySchema } from './common.js';
/** Décision humaine sur une trace ABIS en file de revue (Sprint 3). */
export const abisDecisionSchema = z.object({
    decision: z.enum(ABIS_DECISIONS),
    commentaire: z.string().max(2000).optional(),
});
export const listAbisEnAttenteQuerySchema = paginationQuerySchema;
//# sourceMappingURL=abis.js.map